import React, { useEffect } from 'react';
import './style.css';
import { Route, Routes, useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { ConfigProvider } from 'antd';
import thTH from 'antd/locale/th_TH';
import { currentUser } from './functions/auth';
import AdminRoute from './routes/AdminRoute';
import PublicRoute from './routes/PublicRoute';
import Login from './controller/pages/auth/login';
import Register from './controller/pages/auth/register';
import MemberDataBase from './controller/pages/admin/dashborad/memberDataBase';
import Profile from './controller/pages/admin/profile/Profile';

// AnimatedRoutes: trigger CSS page-enter animation ทุกครั้งที่ pathname เปลี่ยน
// key=pathname บังคับให้ React สร้าง element ใหม่ -> @keyframes page-enter ทำงาน
function AnimatedRoutes() {
    const location = useLocation();
    return (
        <div key={location.pathname} className="page-transition">
            <Routes location={location}>
                {/* Public routes */}
                <Route path="/" element={<PublicRoute><Login /></PublicRoute>} />
                <Route path="/login" element={<PublicRoute><Login /></PublicRoute>} />
                <Route path="/register" element={<PublicRoute><Register /></PublicRoute>} />

                {/* Protected routes */}
                <Route path="/memberdata" element={<AdminRoute><MemberDataBase /></AdminRoute>} />
                <Route path="/profile" element={<AdminRoute><Profile /></AdminRoute>} />
            </Routes>
        </div>
    );
}

function App() {
    const dispatch = useDispatch();

    useEffect(() => {
        const initializeAuth = async () => {
            const token = localStorage.getItem('token');

            if (token) {
                try {
                    // ตรวจสอบ token กับ server
                    const res = await currentUser(token);
                    dispatch({
                        type: 'LOGGED_IN_USER',
                        payload: {
                            id: res.data.id,
                            village: res.data.village,
                            role: res.data.role,
                            token,
                            phase: res.data.phase,
                        },
                    });
                    console.log('User authenticated successfully');
                } catch (err) {
                    console.error('Authentication failed:', err);
                    localStorage.removeItem('token');
                    dispatch({ type: 'LOGOUT', payload: null });
                }
            } else {
                dispatch({ type: 'LOGOUT', payload: null });
            }
        };

        initializeAuth();
    }, [dispatch]);

    return (
        <ConfigProvider
            locale={thTH}
            theme={{
                token: {
                    colorPrimary: '#ff5a2f',
                    colorLink: '#ff5a2f',
                    colorLinkHover: '#ff7a45',
                    borderRadius: 10,
                    fontFamily: "'Prompt', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
                },
                components: {
                    Button: {
                        primaryShadow: '0 4px 12px rgba(255, 90, 47, 0.3)',
                    },
                    Segmented: {
                        itemSelectedBg: '#ff5a2f',
                        itemSelectedColor: '#ffffff',
                    },
                },
            }}
        >
            <div className="App app-root">
                <main className="app-main">
                    <AnimatedRoutes />
                </main>
            </div>
        </ConfigProvider>
    );
}

export default App;
